import React from 'react';


import classes from './ModalSafetyMessage.css';


const modalSafetyMessage = (props) => {

    
    return (
        <div className={classes.ModalSafetyMessage}>
            <h2>{props.message}</h2>
            <div className={classes.ButtonGroup}>
                <h1 className={[classes.Yes, classes[props.btnType]].join(' ')}
                    onClick={props.yesClicked}>YES</h1>
                <h1 className={classes.No} onClick={props.noClicked}>NO</h1>
            </div>
        </div>
    )
}

export default modalSafetyMessage;


// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalSafetyMessage/ModalSafetyMessage.js